import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store'; // Redux Toolkit store
import ThemeContext from './context/ThemeContext';
import { I18nProvider } from './context/I18nContext';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { applyBrandingToDocument } from './config/branding';

applyBrandingToDocument();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const recaptchaKey = String(process.env.REACT_APP_RECAPTCHA_SITE_KEY || '').trim();
const root = ReactDOM.createRoot(rootElement);

const appTree = (
  <Provider store={store}>
    <BrowserRouter basename='/' future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <I18nProvider>
        <ThemeContext>
          <App />
        </ThemeContext>
      </I18nProvider>
    </BrowserRouter>
  </Provider>
);

root.render(
  <React.StrictMode>
    {recaptchaKey ? (
      <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>{appTree}</GoogleReCaptchaProvider>
    ) : (
      appTree
    )}
  </React.StrictMode>
);
reportWebVitals();
